// @ts-nocheck
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const SSE_EVENTS = {
  NEED_NOTIFICATION_PAGE_REFRESH: 'need_notification_page_refresh',
  NEED_REPORT_PAGE_REFRESH: 'need_report_page_refresh',
  NEED_SYSTEM_TASK_PAGE_REFRESH: 'need_system_task_page_refresh',

  NEED_ENTITY_PAGE_REFRESH: 'need_entity_page_refresh',
  NEED_ENTITY_CHAT_PAGE_REFRESH: 'need_entity_chat_page_refresh',
  NEED_ATTRIBUTES_DATA_PAGE_REFRESH: 'need_attributes_data_page_refresh',
  NEED_ARCHIVE_ENTITY_PAGE_REFRESH: 'need_archive_entity_page_refresh',
  NEED_FREEZE_ENTITY_PAGE_REFRESH: 'need_freeze_entity_page_refresh',
  NEED_DOCUMENT_PAGE_REFRESH: 'need_document_page_refresh',
  NEED_ATTRIBUTE_DOCUMENT_SSE: 'Document upload',

  AUTOMATION_NOTIFICATION: 'automation_event_notification',
  DB_SYNC: 'ReportDB Sync',
  REGULATORY_MAPPING_NOTIFICATION: 'regulatory_mapping_notification',
  NEED_REGULATORY_MAPPING_PAGE_REFRESH: 'need_regulatory_mapping_page_refresh',
};

export const COUNTER_EVENTS = new Set([
  SSE_EVENTS.NEED_NOTIFICATION_PAGE_REFRESH,
  SSE_EVENTS.NEED_REPORT_PAGE_REFRESH,
  SSE_EVENTS.NEED_SYSTEM_TASK_PAGE_REFRESH,
  SSE_EVENTS.NEED_REGULATORY_MAPPING_PAGE_REFRESH,
]);

export const ENTITY_EVENTS = new Set([
  SSE_EVENTS.NEED_ENTITY_PAGE_REFRESH,
  SSE_EVENTS.NEED_ENTITY_CHAT_PAGE_REFRESH,
  SSE_EVENTS.NEED_ATTRIBUTES_DATA_PAGE_REFRESH,
  SSE_EVENTS.NEED_ARCHIVE_ENTITY_PAGE_REFRESH,
  SSE_EVENTS.NEED_FREEZE_ENTITY_PAGE_REFRESH,
  SSE_EVENTS.NEED_DOCUMENT_PAGE_REFRESH,
  SSE_EVENTS.NEED_ATTRIBUTE_DOCUMENT_SSE,
]);

export const DB = new Set([SSE_EVENTS.DB_SYNC]);

const initialState = {
  counterEvents: {
    [SSE_EVENTS.NEED_NOTIFICATION_PAGE_REFRESH]: 0,
    [SSE_EVENTS.NEED_REPORT_PAGE_REFRESH]: 0,
    [SSE_EVENTS.NEED_SYSTEM_TASK_PAGE_REFRESH]: 0,
    [SSE_EVENTS.NEED_REGULATORY_MAPPING_PAGE_REFRESH]: 0,
  },
  entityEvents: {
    [SSE_EVENTS.NEED_ENTITY_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_ENTITY_CHAT_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_ATTRIBUTES_DATA_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_ARCHIVE_ENTITY_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_FREEZE_ENTITY_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_DOCUMENT_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_ATTRIBUTE_DOCUMENT_SSE]: {},
  },
  dbSyncEvents: {
    [SSE_EVENTS.DB_SYNC]: {},
  },
};

const sseSlice = createSlice({
  name: 'sse',
  initialState,
  reducers: {
    /**
     * on receiving event, we will increase the counterEvents key value by 1,
     * but there is no use of this value
     * we will track the change in value, and will perform certain actions
     */
    bumpCounter(state, action) {
      state.counterEvents[action.payload] += 1;
    },
    /**
     * for entityEvents we will need entity_id and entity_type to identify the entity,
     * so that we can perform action on that entity, whose entity_id & entity_type we have received through sse
     */
    addEntityEvent(state, action) {
      const { sseType, ...eventData } = action.payload;
      state.entityEvents[sseType] = { ...eventData };
    },
    dbSyncEvent(state, action) {
      const { data, sseType } = action.payload;
      // Increment the counter to trigger component re-renders
      state.dbSyncEvents[sseType] = { data, sseType };
    },
  },
});

export const { bumpCounter, addEntityEvent, dbSyncEvent } = sseSlice.actions;
export default sseSlice.reducer;
